import Vue from 'vue'
import './plugins/vuetify'
import router from './router';
import App from './App.vue'
import store from './store'
import Meta from 'vue-meta'
import i18n from '@/i18n'

Vue.config.productionTip = false

Vue.use(Meta)

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
